import * as React from 'react';
import {
  Button,
  Chip,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Typography,
} from '@mui/material';
import AutoAwesomeIcon from '@mui/icons-material/AutoAwesome';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import RocketLaunchIcon from '@mui/icons-material/RocketLaunch';
import { V2_ADMIN_URL } from '@next-pontos/settings';

const DISMISS_STORAGE_KEY = '@next-pontos/v2-admin-invite-dismissed';

const HIGHLIGHTS = [
  'Interface mais moderna, rápida e responsiva.',
  'Navegação simplificada para o dia a dia.',
  'Mesmos dados e mesmas permissões que você já usa.',
];

const AVAILABLE_AREAS = ['Dashboards', 'Usuários', 'Cartões', 'Chamados', 'Clientes', 'Ofertas', 'Emissões'];

export function V2InviteModal() {
  const [open, setOpen] = React.useState(false);

  React.useEffect(() => {
    if (!V2_ADMIN_URL) {
      return;
    }

    const dismissed = window.localStorage.getItem(DISMISS_STORAGE_KEY) === 'true';

    if (!dismissed) {
      setOpen(true);
    }
  }, []);

  const dismiss = React.useCallback(() => {
    window.localStorage.setItem(DISMISS_STORAGE_KEY, 'true');
    setOpen(false);
  }, []);

  const goToV2 = React.useCallback(() => {
    window.localStorage.setItem(DISMISS_STORAGE_KEY, 'true');
    window.location.href = V2_ADMIN_URL;
  }, []);

  if (!V2_ADMIN_URL) {
    return null;
  }

  return (
    <Dialog open={open} onClose={dismiss} maxWidth="sm" fullWidth>
      <DialogTitle sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
        <AutoAwesomeIcon color="primary" />
        Experimente o novo painel (V2)
      </DialogTitle>
      <DialogContent dividers>
        <Typography variant="body1" gutterBottom>
          Lançamos uma nova versão do painel administrativo, repensada para ser mais
          agradável e eficiente no seu dia a dia.
        </Typography>

        <List dense>
          {HIGHLIGHTS.map((item) => (
            <ListItem key={item} disableGutters>
              <ListItemIcon sx={{ minWidth: 32 }}>
                <CheckCircleIcon color="success" fontSize="small" />
              </ListItemIcon>
              <ListItemText primary={item} />
            </ListItem>
          ))}
        </List>

        <Typography variant="subtitle2" sx={{ mt: 1, mb: 1 }}>
          Já disponível na V2:
        </Typography>
        <div style={{ display: 'flex', flexWrap: 'wrap', gap: 8 }}>
          {AVAILABLE_AREAS.map((area) => (
            <Chip key={area} label={area} color="primary" variant="outlined" size="small" />
          ))}
        </div>

        <div
          style={{
            display: 'flex',
            gap: 8,
            marginTop: 16,
            padding: 12,
            borderRadius: 8,
            backgroundColor: 'rgba(177, 121, 63, 0.08)',
          }}
        >
          <InfoOutlinedIcon color="warning" fontSize="small" />
          <Typography variant="body2" color="text.secondary">
            Ainda estamos migrando as funcionalidades. Áreas como Comissões,
            Financeiro, Agências, Leads, Cupons e Programas continuam disponíveis apenas
            aqui na V1 por enquanto.
          </Typography>
        </div>
      </DialogContent>
      <DialogActions sx={{ px: 3, py: 2 }}>
        <Button onClick={dismiss} color="inherit">
          Continuar na V1
        </Button>
        <Button
          onClick={goToV2}
          variant="contained"
          startIcon={<RocketLaunchIcon />}
        >
          Ir para a V2
        </Button>
      </DialogActions>
    </Dialog>
  );
}
